export const SUPPORTED_TYPES = [
    'text',
    'category',
    'integer',
    'float',
    'money',
    'fraction',
    'date',
    'year',
    'coordinates',
    'polygon',
];
